import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import LinkJump from '@gp/components/LinkJump';
import PlatformIcon from '@gp/components/PlatformIcon/PlatformImg';
import { queryJumpable } from '@gp/utils/common';
import { getProjectDetailsPagePath, goToProjectDetailsPageByPath } from '@gp/utils/project';
import classnames from 'classnames';
import React, { useMemo } from 'react';
import { Bubble } from 'tea-component';
// @ts-ignore
import { STAGE_VALUE_TEXT } from '@gp/constants/select';
import { PROJECT_DETAIL_STORAGE_KEY } from '@gp/constants/storageKeys';
import type { IProjectGRActionItemProjectVO } from '@gp/types/grActionItems';
import { storage } from '@gp/utils/utils';
import type { IBaseProps } from '@home/types/common';
import './index.scss';

interface IProjectItemProps extends IBaseProps {
  data?: IProjectGRActionItemProjectVO | null;
}

const ProjectColumnItem: React.FC<IProjectItemProps> = (props) => {
  const {
    style,
    className,
    data,
    isShowStage = false,
    isShowTextStudio = false,
    isShowInfoList = true,
  } = props;
  const {
    project_id: projectId,
    project,
    studio,
    cover,
    platform,
    bo,
    pteam,
    stage,
    business_owner,
  } = data || {};

  const platformCur = useMemo(() => {
    if (Array.isArray(platform)) {
      return platform;
    }
    if (platform && typeof platform === 'string') {
      const arrPlatform = platform?.split(',') || [];
      return arrPlatform;
    }
    return [];
  }, [platform]);

  const boCur = useMemo(() => {
    return bo || business_owner;
  }, [business_owner, bo]);

  const jumpParams = {
    id: projectId || '',
    name: project,
    tab: 'milestone',
  };

  const url = getProjectDetailsPagePath?.(jumpParams);

  const handleNavigate = (e?: React.MouseEvent) => {
    if (!queryJumpable(e)) return;
    const { milestone_id: milestoneId } = data?.gate_review || {};
    storage.setSessionStorageItem(
      PROJECT_DETAIL_STORAGE_KEY.GPOP_CACHE_MILESTONE_ID_STORAGE_KEY,
      milestoneId,
    );
    goToProjectDetailsPageByPath(url);
  };

  return (
    <div
      style={style}
      className={classnames(
        'dbg-initial-line-height dbg-gr-action-items-project-context dbg-project-column-item',
        className,
      )}
    >
      <div className="dbg-gr-action-items-project-context__left">
        <LinkJump
          className="dbg-cursor-pointer"
          stopPropagation={false}
          url={url}
          onClick={handleNavigate}
        >
          <GeneralImageNew
            className="dbg-gr-action-items-project-context__project-icon"
            domain="game"
            width={54}
            height={54}
            src={cover || '-'}
          />
        </LinkJump>
      </div>
      <div className="dbg-gr-action-items-project-context__right">
        <div className="dbg-gr-action-items-project-context__project-name-wrapper">
          <LinkJump
            className="dbg-cursor-pointer"
            stopPropagation={false}
            url={url}
            onClick={handleNavigate}
          >
            <EllipsisTextBubble
              className="dbg-gr-action-items-project-context__project-name"
              text={project || '-'}
              ellipsisLineClamp={2}
              customBubbleContent={project}
            />
          </LinkJump>
        </div>
        {isShowTextStudio && (
          <div className="dbg-gr-action-items-project-text">
            <Bubble dark arrowPointAtCenter placement="top" content={studio}>
              <span className="dbg-cursor-pointer">{studio || '-'}</span>
            </Bubble>
          </div>
        )}
        <PlatformIcon platform={platformCur?.join(',') || ''} />
        {isShowInfoList && (
          <div className="dbg-gr-action-items-project-context__info-list">
            <div className="dbg-gr-action-items-project-context__info-list-item">
              <div className="dbg-gr-action-items-project-context__studio-name-wrapper">
                <span className="dbg-project-column-item-list-name-span">{'P-team:  '}</span>
                <EllipsisTextBubble
                  className="dbg-gr-action-items-project-context__studio-name"
                  text={pteam || '-'}
                  ellipsisLineClamp={1}
                  customBubbleContent={pteam}
                />
              </div>
              <div className="dbg-gr-action-items-project-context__studio-name-wrapper">
                <span className="dbg-project-column-item-list-name-span">{'BO: '}</span>
                <EllipsisTextBubble
                  className="dbg-gr-action-items-project-context__studio-name"
                  text={boCur || '-'}
                  ellipsisLineClamp={1}
                  customBubbleContent={boCur}
                />
              </div>
              <div className="dbg-gr-action-items-project-context__studio-name-wrapper">
                <span className="dbg-project-column-item-list-name-span">{'Studio: '}</span>
                <EllipsisTextBubble
                  className="dbg-gr-action-items-project-context__studio-name"
                  text={studio || '-'}
                  ellipsisLineClamp={1}
                  customBubbleContent={studio}
                />
              </div>
              {isShowStage && (
                <div className="dbg-gr-action-items-project-context__studio-name-wrapper">
                  <span className="dbg-project-column-item-list-name-span">{'Stage: '}</span>
                  <EllipsisTextBubble
                    className="dbg-gr-action-items-project-context__studio-name"
                    text={STAGE_VALUE_TEXT[stage] || '-'}
                    ellipsisLineClamp={1}
                    customBubbleContent={stage}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectColumnItem;
